import { createSlice } from '@reduxjs/toolkit';

// Load initial state from localStorage if available
const savedState = localStorage.getItem('persist:menu');
let activeMenuItem = '/';

if (savedState) {
  try {
    const parsedState = JSON.parse(savedState);
    if (parsedState.activeMenuItem) {
      activeMenuItem = JSON.parse(parsedState.activeMenuItem);
    }
  } catch (e) {
    console.error('Error parsing menu state from localStorage', e);
  }
}

const initialState = {
  showGreyMenu: false,
  activeSection: null,
  activeMenuItem: activeMenuItem,
  activeSubmenuItem: null
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    toggleGreyMenu: (state, action) => {
      const section = action.payload;
      
      // If section is null, just close the menu
      if (section === null) {
        state.showGreyMenu = false;
        state.activeSection = null;
        return;
      }
      
      // If we're toggling the same section and it's already showing,
      // just toggle its visibility
      if (state.activeSection === section && state.showGreyMenu) {
        state.showGreyMenu = !state.showGreyMenu;
      } else {
        // If it's a different section or the menu is currently closed,
        // always show the menu with the new section
        state.showGreyMenu = true;
        state.activeSection = section;
      }
    },
    setActiveMenuItem: (state, action) => {
      state.activeMenuItem = action.payload;
    },
    closeGreyMenu: (state) => {
      state.showGreyMenu = false;
      state.activeSection = null;
    },
    setActiveSubmenuItem: (state, action) => {
      state.activeSubmenuItem = action.payload;
    }
  }
});

export const { 
  toggleGreyMenu, 
  setActiveMenuItem, 
  closeGreyMenu,
  setActiveSubmenuItem
} = menuSlice.actions;
export default menuSlice.reducer; 